import React, { useState } from 'react'
import comit from "../../Images/careimage3.png"
import ServiceSlider from "../../commanfile/ServiceSlider";
import PsynexaPost1 from "../../Images/careimage1.png"
import PsynexaPost from "../../Images/diamenciacareimage2.avif"
import Tretmentwork from "../../commanfile/Tretmentwork";
import Button from "../../commanfile/Button";
import { FaHandHoldingHeart } from "react-icons/fa6";
import Servicelist from '../../commanfile/Servicelist';



const Geriatric = () => {
  const symtams1 = [
    "Safe and Supportive Environments that promote independence while ensuring patient safety.",
    "Family Guidance & Counseling to help caregivers cope with the emotional and practical aspects of care.",
  ]
  const symtams = [
    " Personalized Care Plans that include medication management, therapy, and lifestyle support.",
    "Comprehensive Assessments to identify early signs of dementia and other age-related conditions."
  ]

  const Data = [


    {
      question: "What is dementia and how is it different from normal aging?",
      answer: "	Dementia is a decline in cognitive function beyond normal aging, affecting memory, thinking, and daily activities. Normal aging may cause mild forgetfulness but does not impair functioning like dementia."
    },
    {
      question: "What are the early signs of dementia that families should look out for?",
      answer: "	Early signs include memory loss, difficulty planning, confusion, misplacing items, and changes in mood or personality."
    },
    {
      question: "At what age does dementia usually occur?  ",
      answer: "	Dementia typically begins after age 65, but early-onset forms can occur in younger adults."
    },
    {
      question: "Is dementia a disease on its own or a symptom of other conditions?  ",
      answer: "	Dementia is a syndrome caused by various diseases, including Alzheimer's, vascular issues, or other neurological conditions."
    },
    {
      question: "Can dementia be treated or reversed? ",
      answer: "Dementia cannot be cured or reversed, but symptoms can be managed to slow progression and improve quality of life."
    },
    {
      question: "	What kinds of care do people with dementia need on a daily basis? ",
      answer: "	People with dementia need help with daily tasks, medication management, safety supervision, and emotional support."
    },
    {
      question: "How can geriatric care improve quality of life for elderly patients? ",
      answer: "	Geriatric care addresses complex health needs, promoting independence, managing chronic diseases, and enhancing well-being."
    },
    {
      question: "Does dementia always get worse with time?  ",
      answer: "Dementia usually worsens over time but progression varies individually."
    },
    {
      question: "	What role do families play in dementia and elderly care? ",
      answer: "	Families provide emotional support, decision-making, care coordination, and help maintain quality of life."
    },
    {
      question: "	Are there therapies or activities that can help slow down dementia? ",
      answer: "Therapies like cognitive stimulation, physical activity, and social engagement may slow decline"
    },
    {
      question: "Can changes in lifestyle or diet help prevent dementia? ",
      answer: "Healthy diet, exercise, mental activity, and social interaction can reduce dementia risk."
    },
    {
      question: "Is memory loss always a sign of dementia?  ",
      answer: "Not all memory loss signals dementia; mild forgetfulness can be normal aging or other conditions."
    },
    {
      question: "	How can caregivers cope with the emotional and physical stress of caring for someone with dementia?  ",
      answer: "Caregivers benefit from support groups, respite care, counseling, and stress management techniques."
    },
    {
      question: "Are medications available for managing dementia symptoms?  ",
      answer: "Medications can help manage symptoms but do not cure dementia."
    },
    {
      question: "	What kind of specialists provide dementia and geriatric care?  ",
      answer: "Specialists include neurologists, geriatricians, psychiatrists, and occupational therapists."
    },
    {
      question: "Can dementia patients continue to live independently? ",
      answer: "Early-stage patients may live independently; advanced stages require increasing support."
    },
    {
      question: "Does dementia affect only memory, or can it also affect mood and behavior? ",
      answer: "	Dementia affects memory, mood, behavior, causing depression, agitation, or personality changes."
    },
    {
      question: "Is geriatric care only for patients with dementia, or for all elderly health needs?  ",
      answer: "	Geriatric care covers all elderly health needs, including dementia, chronic diseases, mobility, and mental health."
    },
  ]



  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }

  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto ">
        <div className=" pb-12">
          <ServiceSlider
            classname={"sm:flex p-2 items-center flex-row-reverse"}
            title={"DEMENTIA & GERIATRIC CARE"}
            content={
              "Dementia and aging bring unique challenges—not just for the individual, but for their families as well. "
            }
            maincontent={
              "Forgetfulness, confusion, and changes in behavior can feel overwhelming, but with the right care and support, dignity and quality of life can be preserved. Geriatric care is not just about managing medical needs—it is about offering patience, understanding, and compassion to help our elders feel valued and respected. Remember, aging is not a decline in worth—it is a stage of life that deserves comfort, connection, and care."}

            imgs={PsynexaPost}
          />
        </div>

        <div className="py-16  bg-[#fef8f0] ">
          <div className="text-center mx-auto border-b-4">
            <p className="font-roboto text-3xl font-bold line-clamp-5 ">
              WE FOCUS ON.....
            </p>
            <div className="md:flex flex-row-reverse mx-auto items-center justify-center py-4">
              <div>
                <img
                  src={PsynexaPost1}
                  className="border-black rounded-2xl  h-[400px] w-[350px]"
                />
              </div>
              <div>
                <div className="lg:flex justify-between mx-auto px-6 sm:px-2 gap-10 ">
                  <div className=" ">
                    <Servicelist Symtams={symtams} />
                  </div>
                  <div className="">
                    <Servicelist Symtams={symtams1} />
                  </div>
                </div>
                <div className="mx-auto pt-10 ">
                  <Button
                    className={
                      "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#50b1a4] p-1 rounded-full h-[40px] w-[200px]"
                    }
                    btnName={"Get Appointment"}
                    link={"/ContactUs"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto py-4">
          <div className="lg:flex flex-row-reverse justify-around pt-3 items-center">
            <div className=" lg:w-[50%]  w-full ">
              <p className=" flex gap-2 px-2 font-roboto font-semibold text-3xl text-[#469B8F]">
                <FaHandHoldingHeart className="" />
               Together, Toward a Brighter Mind.
              </p>

              <p className=" mx-auto text-justify text-lg    py-3 px-5">
                Aging is a natural part of life, but it can also bring unique challenges that require specialized care and understanding. Conditions like dementia often affect memory, thinking, and behavior, leaving both patients and families overwhelmed. At such times, compassionate support and timely medical intervention make all the differences.
              </p>

              <p className=" mx-auto text-justify text-lg py-2 px-5">
                At Psynexa Mind Care Hospital, our Dementia & Geriatric Care services are designed to provide holistic care for the elderly, ensuring dignity, safety, and comfort at every stage. From early detection and diagnosis to long-term management, our team works closely with patients and families to address not just medical needs, but also emotional and social well-being.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                Growing older should never mean losing your sense of self or quality of life. With the right support, seniors can continue to lead fulfilling, meaningful lives. Our goal is to stand by both patients and their families, offering care rooted in compassion, respect, and expertise.
              </p>
            </div>
            <div className="">
              <img
                src={comit}
                className="w-[400px] mx-auto h-[400px] p-2  "
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="mx-auto bg-[#bde3de] py-10 ">
          <p className="font-roboto sm:text-xl  capitalize text-base text-center pt-3">
            Mental health problems are treatable with therapies, medications,
            and lifestyle support tailored to each individual.
          </p>
          <p className="font-roboto sm:text-xl capitalize text-base text-center pt-3">
            Early diagnosis and personalized care can greatly improve well-being
            and quality of life.
          </p>
          <div className="">
            <Tretmentwork />
          </div>
          <div className=""></div>
        </div>


        <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};


export default Geriatric